import { AxiosInstance } from 'axios';
import { errorHandler } from './errorHandler/errorHandler';

export default (axios: AxiosInstance) => ({
  create: async (partnerId: string) => {
    const url = `/api/v1/api-key/create/${partnerId}`;
    return errorHandler<{ api_key_id: string }>(
      axios.post(url),
      'create - api-key',
      { url }
    );
  },
  getAll: async () => {
    const url = `/api/v1/api-key`;
    return errorHandler<ApiKey[]>(axios.get(url), 'getAll - api-key', {
      url,
    });
  },
  update: async (apiKeyId: string, body: ApiKeyUpdateBody) => {
    const url = `/api/v1/api-key/${apiKeyId}`;
    return errorHandler(axios.patch(url, body), 'update - api-key', { url });
  },
  rotate: async (apiKeyId: string) => {
    const url = `/api/v1/api-key/${apiKeyId}/rotate`;
    return errorHandler(axios.post(url), 'rotate - api-key', { url });
  },
  invalidate: async (apiKeyId: string) => {
    const url = `/api/v1/api-key/${apiKeyId}/invalidate`;
    return errorHandler(axios.post(url), 'invalidate - api-key', { url });
  },
});
